import { useState } from 'react';
import { CampaignStatus } from '../../../../types/enums/campaign-enums';
import { FormControlLabel, FormGroup, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setLiveCampaign } from '../../../../stores/redux/actions/campaignManagementActions/_matrixActions';

export const SCUILiveCampaignFilter = ({ action }: { action?: () => void }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const store = useSelector((state: any) => state.campaignLiveCampaign);

    const [checked, setChecked] = useState(store.data === CampaignStatus.Active);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newStatus: number = event.target.checked ? CampaignStatus.Active : -1;

        setChecked(event.target.checked);

        dispatch(setLiveCampaign(newStatus));

        action?.();
    };

    return (
        <>
            <FormGroup>
                <FormControlLabel
                    control={<Switch checked={checked} onChange={handleChange} />}
                    label={t('campaignManagement.save.step.stackable.liveCampaigns')}
                />
            </FormGroup>
        </>
    );
};
